import GenericContentSearch from './helpers/GenericContentSearch';

export default GenericContentSearch({
  search: { name: 'Forms', type: 'Form' },
});
